import {    
    RESET_PASSWORD_REQUESTED,
  RESET_PASSWORD_PROCESSING,
  RESET_PASSWORD_SUCCESSED,
  RESET_PASSWORD_FAILED,
  } from '../../constants/actionTypes';
  
  const initialState = {
    listData: {},
    isProcessing: null,
    isSuccess: null,
    hasErrors: null,
  };

 
  export const resetPasswordStore = (state = initialState, action) => {
    switch (action.type) {
        case RESET_PASSWORD_REQUESTED: {
            return {
            ...state,
            listData: {},
            loading: true,
            hasErrors: null,
            isProcessing: true,
            isSuccess: null,
            };
        }
        case RESET_PASSWORD_PROCESSING: {
            return {
            ...state,
            listData: {},
            hasErrors: null,
            loading: true,
            isProcessing: true,
            isSuccess: null,
            };
        }
        case RESET_PASSWORD_SUCCESSED: {
            return {
                ...state,
                listData: action.data,
                hasErrors: null,
                loading: false,
                isProcessing: false,
                isSuccess: true,
            };
        }
        case RESET_PASSWORD_FAILED: {
            return {
                ...state,
                listData: {},
                hasErrors: action.data,
                isProcessing: false,
                loading: false,
                isSuccess: false,
            };
        }

        default: {
            return {
            ...state,
            };
        }
    }
  };
  
  export default resetPasswordStore;
  